'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

ChangeUserPasswordModalController=(_dec=














































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(ChangeUserPasswordModalController,_BaseController);_createClass(ChangeUserPasswordModalController,null,[{key:'$inject',get:function(){return['$modalInstance','userService','uiCommandFactory','uncaughtErrorHandler']}}]);function ChangeUserPasswordModalController($modalInstance,userService,uiCommandFactory,uncaughtErrorHandler){_classCallCheck(this,ChangeUserPasswordModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._$modalInstance=$modalInstance;_this._userService=userService;_this._changePasswordCommand=uiCommandFactory.makeForModal($modalInstance,_this._changePassword.bind(_this));_this._submissionErrorTypes={invalidCurrentPassword:'invalid current password.',minimumLengthProposed:'invalid minimum length'};_this._submissionFailed=!1;return _this}ChangeUserPasswordModalController.prototype.onCancel=function onCancel(){this._$modalInstance.dismiss()};ChangeUserPasswordModalController.prototype.
_changePassword=function(){var ref=_asyncToGenerator(function*(){
this._submissionFailed=!1;

let updateResult=yield this._userService.changePassword({
current:this.currentPassword,
proposed:this.proposedPassword});


if(!SocketResponse.succeeded(updateResult)){
this._submissionFailed=!0;
return ModalSubmissionResult.KeepOpen;
}

return ModalSubmissionResult.Close();
});function _changePassword(){return ref.apply(this,arguments)}return _changePassword}();_createClass(ChangeUserPasswordModalController,[{key:'currentPassword',get:function(){return this._currentPassword},set:function(currentPassword){this._currentPassword=currentPassword}},{key:'proposedPassword',get:function(){return this._proposedPassword},set:function(proposedPassword){this._proposedPassword=proposedPassword}},{key:'changePasswordCommand',get:function(){return this._changePasswordCommand}},{key:'submissionFailed',get:function(){return this._submissionFailed}}]);return ChangeUserPasswordModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_changePassword',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_changePassword'),_class.prototype)),_class));


module.exports=ChangeUserPasswordModalController;
//# sourceMappingURL=changeUserPasswordModalController.js.map
